import { DocumentEntity } from '@domain';

/**
 * Piso das barras de progresso do import (upload e geração). O valor real começa
 * em 0% — e uma barra vazia parada passa a sensação de que travou. Um fiozinho
 * visível já diz "está andando" sem mentir sobre o quanto falta.
 */
export const MIN_IMPORT_PERCENT = 2;

/** Aplica o piso de 2% e corta em 100 (arredondando), para qualquer % de import. */
export function clampImportPercent(percent: number): number {
    return Math.min(100, Math.max(MIN_IMPORT_PERCENT, Math.round(percent)));
}

/**
 * % PERSISTIDO da conversão de um import em geração, ou `null` quando o backend
 * ainda não reportou nada (job na fila) — aí a tela mostra só o spinner.
 * Compartilhado entre o card do feed e o card do documento dentro do serviço
 * para que as duas barras andem exatamente igual.
 */
export function importGenerationPercent(
    /* Parcial porque o feed devolve o documento resumido (Partial<DocumentEntity>). */
    document?: Pick<DocumentEntity, 'importGenerationProgress'> | null
): number | null {
    const progress = document?.importGenerationProgress;
    if (!progress || typeof progress.percent !== 'number') return null;

    return clampImportPercent(progress.percent);
}
